import React from "react";
import { Row, Col, Button } from "shards-react";

/**
 * Función que devuelve un conjunto de botones de contorno con diferentes temas.
 * @function
 * @name NormalOutlineButtons
 * @returns {JSX.Element} Elemento JSX que contiene una fila de botones de contorno.
*/

const NormalOutlineButtons = () => (
  <Row>
    <Col>
      <Button outline theme="primary" className="mb-2 mr-1">
        Primary
      </Button>
      <Button outline theme="secondary" className="mb-2 mr-1">
        Secondary
      </Button>
      <Button outline theme="success" className="mb-2 mr-1">
        Success
      </Button>
      <Button outline theme="danger" className="mb-2 mr-1">
        Danger
      </Button>
      <Button outline theme="warning" className="mb-2 mr-1">
        Warning
      </Button>
      <Button outline theme="info" className="mb-2 mr-1">
        Info
      </Button>
      <Button outline theme="dark" className="mb-2 mr-1">
        Dark
      </Button>
      <Button outline theme="light" className="mb-2 mr-1">
        Light
      </Button>
    </Col>
  </Row>
);

export default NormalOutlineButtons;
